








































































































































































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import { pagnition } from "@/utils/commonConfig";
import { timeFormat } from "@/utils/index";
import { Bool } from "@/pbjs/external/ticket/ticket_pb";
import { PreCreateUserResp } from "@/pbjs/external/user/user_pb";

@Component({
  name: "Completed",
})
export default class Completed extends Vue {
  @Provide() private searchForm: any = {
    ticketId: null, // ticket id
    orderId: null, // 借款ID
    isReloan: null, //首付贷
    itemId: null, //工单类型
    verifyResult: null, //审核结果
    inspectionResult: null, // 质检结果
    createTimeRange: [], //创建时间
    assignTimeRange: [], //分配时间
    completeTimeRange: [], // 完成时间
  };
  @Provide() private labelPosition: string = "right";
  @Provide() private resultData: any = []; //table列表
  @Provide() private isSearchFormActionDone: boolean = false; //loading
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0; // lee 分页参数 目前分页是自己处理的
  @Provide() private pagnition: any = pagnition;

  @Provide() private activeName: string = "first";
  @Provide() private reloanOptions: any = [
    { name: "v0707.FirstLoan", value: Bool.BOOL_NO }, // 首贷
    { name: "v0707.Reloan", value: Bool.BOOL_YES }, // 复贷
  ];
  @Provide() private inspectionOptions: any = []; //质检结果
  @Provide() private ticketitemOptions: any = [
    { name: "Phone Verify", value: 100 },
    { name: "Info Review", value: 101 },
    { name: "Corporate Loan Phone Verify", value: 107 },
  ]; //工单分类
  @Provide() private verifyresultOptions: any = []; //审核结果
  @Provide() private applist: any = []; 
  private created() {
    this.getParams();
    this.getAuditOrderList();
  }
  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getAuditOrderList();
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getAuditOrderList();
  }
  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getAuditOrderList();
    }
  }
  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getAuditOrderList();
  }
  // 处理工单
  handleOrder(row: any) {
    let routeData = this.$router.resolve({
      path: "/auditDetail",
      query: {
        orderid: row.ticket.orderid,
        ticketitemid: row.ticket.itemid, //工单类型
        ticketid: row.ticket.id,
        customerid: row.ticket.customerid,
        assignuid: row.ticket.assignuid,
        isAudi:'false',
        appname: row.ticket.appname,
      },
    });
    window.open(routeData.href, "_blank");
  }
  //  lee 搜索操作
  private searchFormAction() {
    this.pagerCount = 0;
    this.pageIndex = 1;
    this.isSearchFormActionDone = true;
    this.getAuditOrderList();
  }
  private async getParams() {
    const { getParamReq, getParamRequest }: any = await import(
      "@/request/inspectOrderManage"
    );
    let res = await getParamRequest.handleHttp(getParamReq(), this);
    if (res && res.right) {
      this.inspectionOptions = res.inspectionresultmapMap;
      // this.ticketitemOptions = res.ticketitemList;
      this.verifyresultOptions = res.verifyresultmapMap;
    }
  }
  // 搜索框信息
  private searchAction(): any {
    let _arg: any = {
      Page: {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      },
      ticketId: this.searchForm.ticketId ? Number(this.searchForm.ticketId) : null, // Ticket Id
      action: "new", //new，part，complete
      orderId: this.searchForm.orderId ? this.searchForm.orderId : null, //借款id
      isReloan: this.searchForm.isReloan ? Number(this.searchForm.isReloan) : 0, //首付贷 0：不选，1：复贷，2：首贷
      itemId: [102], // 工单类型
      prevItemId: +this.searchForm.itemId,
      verifyResult: this.searchForm.verifyResult
        ? Number(this.searchForm.verifyResult)
        : null, //审核结果
      inspectionResult: this.searchForm.inspectionResult
        ? Number(this.searchForm.inspectionResult)
        : null, // 质检结果
        appname: this.searchForm.appname?.toString()
    };
    //完成时间范围
    if (
      this.searchForm.completeTimeRange &&
      this.searchForm.completeTimeRange.length > 0
    ) {
      _arg.completeTimeRange =
        timeFormat(this.searchForm.completeTimeRange[0].getTime()) +
        " - " +
        timeFormat(this.searchForm.completeTimeRange[1].getTime());
    }
    //创建时间
    if (this.searchForm.createTimeRange && this.searchForm.createTimeRange.length > 0) {
      _arg.createTimeRange =
        timeFormat(this.searchForm.createTimeRange[0].getTime()) +
        " - " +
        timeFormat(this.searchForm.createTimeRange[1].getTime());
    }
    //分配时间
    if (this.searchForm.assignTimeRange && this.searchForm.assignTimeRange.length > 0) {
      _arg.assignTimeRange =
        timeFormat(this.searchForm.assignTimeRange[0].getTime()) +
        " - " +
        timeFormat(this.searchForm.assignTimeRange[1].getTime());
    }
    return _arg;
  }
  //   获取列表
  private async getAuditOrderList() {
    let _arg: any = this.searchAction();
    const { getVerifyListReq, getVerifyListRequest }: any = await import(
      "@/request/inspectOrderManage"
    );
    let res = await getVerifyListRequest.handleHttp(getVerifyListReq(_arg), this);
    this.isSearchFormActionDone = res ? res.loading : false;
    if (res) {
      let _result =
        typeof res.listList == "object" ? res.listList : JSON.parse(res.listList);
        this.applist = res.applist
      if (_result) {
        this.resultData = _result.map((item: any) => {
          item.ticket.ctime = timeFormat(Number(item.ticket.ctime));
          item.ticket.assigntime = timeFormat(Number(item.ticket.assigntime));
          item.ticket.isreloan = item.ticket.isreloan
            ? this.$t("v0707.Reloan")
            : this.$t("v0707.FirstLoan");
          let itemidname = "";
          switch (item.ticket.previtemid) {
            case 100:
              itemidname = "Phone Verify";
              break;
            case 101:
              itemidname = "Info Review";
              break;
            case 102:
              itemidname = "Quality Inspection";
              break;
            case 107:
              itemidname = "Corporate Loan Phone Verify";
              break;
          }
          this.$set(item, "itemidname", itemidname);
          return item;
        });
      }
      if (res.pageout || res.total) {
        this.pagerCount = res.total ? res.total : res.pageout.total;
      }
    }
  }
}
